import { getPromotions, promotionHasLogo, PromotionType } from "@/states/promotion-state";
import { computed, defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    props: {
        balance: {
            type: Number,
            required: true,
        },
        type: {
            type: String as PropType<Exclude<PromotionType, 'none'>>,
            required: true,
        },
    },
    setup(props) {
        const promotions = getPromotions();

        const imageSize = computed(() => promotions.packages[props.type].imageSize);
        
        return {
            imageSize,
            promotionHasLogo,
        };
    },
})